import { SignUpPhoneCodeCard } from './SignUpPhoneCodeCard';

export const SignUpVerifyPhone = () => {
  return <SignUpPhoneCodeCard />;
};
